module.exports = __webpack_public_path__ + "img/logo_landing.536e1aa1.png";